/**
 * Invoca internal help popover jQuery plugin
 */

import "bootstrap";
import $ from "jquery";

$.fn.helpPopover = function(config) {
  config = config || {};

  var placement = config.placement || 'right';
  var title = config.title || '';
  var trigger = config.trigger || "focus";
  var classes = 'js-popover ui-help-text';
  var toggle = config.toggle || 'popover';
  var stylize = typeof config.style === 'undefined' || config.style;
  var animation = typeof config.animation === 'undefined' || config.animation;
  var container = config.container || false;

  if (trigger === 'hover' || !stylize) {
    classes += " ui-help-hover";
  }

  this.addClass(classes);
  this.attr('tabindex', '0');
  this.attr('title', title);
  this.data('toggle', toggle);
  this.data('html', true);
  this.data('trigger', trigger);
  this.data('placement', placement);
  this.data('original-title', title);
  this.data('animation', animation);
  this.data('container', container);

  if (toggle === 'popover') {
    if (config.content) {
      this.data('content', config.content);
      this.popover();
    } else {
      throw new Error('Help Popover: Must specify content');
    }
  } else {
    this.tooltip();
  }

  return this;
};
